import { createStateHook } from 'react-sweet-state';
import { store } from '../../main';
export var useAppErrors = createStateHook(store, {
  selector: function selector(state, _ref) {
    var _state$appsErrors$app;
    var appId = _ref.appId;
    return {
      appErrors: (_state$appsErrors$app = state.appsErrors[appId]) !== null && _state$appsErrors$app !== void 0 ? _state$appsErrors$app : null
    };
  }
});